<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper white">
            <h2 class="title text-center">負碳拚拚看</h2>
            <p class="carbon-text-sm">
                我們可以透過認識、選擇有環保標章、節能標章等標示的商品，來為地球的健康盡一份心力。<br>在負碳拼拼看中，跟著我們一起組合出碳足跡標籤原來的模樣吧！
            </p>
            <button class="buttonStyle" @click.prevent="goView">開始遊戲</button>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
        };
    },
    methods: {
        goView() {
            window.location.href = 'static/puzzle/index.html';
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style scoped>
.buttonStyle {
    background-color: rgba(154, 183, 110, 1);
    color: #ffffff;
    width: 100%;
    border-radius: 12px;
    font-weight: 700;
    font-size: 20px;
    height: 69px;
    border: none;
}
</style>
